(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  /* Hovering a can washes the page in that drink's colour. Done in JS rather
     than with :has(), because the colour is per block -- CSS can match the
     hovered can but cannot read the custom property off it, so a pure-CSS
     version would need one generated rule per can. */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-error404]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Written rather than removed, so the gradient keeps its last colour while
    // it fades out instead of blinking to transparent halfway through.
    var wash = function (can) {
      if (!can) {
        root.style.setProperty('--error404-wash-opacity', '0');
        root.style.removeProperty('--error404-wash-soft');
        return;
      }

      // The gradient's centre is the can's own centre, in percent of the
      // section -- read at hover time because the cans drift as they float.
      var rootRect = root.getBoundingClientRect();
      var canRect = can.getBoundingClientRect();
      var x = ((canRect.left + canRect.width / 2 - rootRect.left) / rootRect.width) * 100;
      var y = ((canRect.top + canRect.height / 2 - rootRect.top) / rootRect.height) * 100;

      root.style.setProperty('--error404-wash', can.getAttribute('data-can-color'));
      root.style.setProperty('--error404-wash-soft', can.getAttribute('data-can-color-soft'));
      root.style.setProperty('--error404-wash-x', x.toFixed(2) + '%');
      root.style.setProperty('--error404-wash-y', y.toFixed(2) + '%');
      root.style.setProperty('--error404-wash-opacity', '1');
    };

    root.querySelectorAll('[data-error-can]').forEach(function (can) {
      if (!can.getAttribute('data-can-color')) return;

      // pointerenter/leave rather than mouseover, so a tap on a phone does not
      // leave the page stuck on the last can's colour.
      can.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse') return;
        wash(can);
      });
      can.addEventListener('pointerleave', function () {
        wash(null);
      });

      // Keyboard gets the same feedback as a pointer.
      can.addEventListener('focus', function () {
        wash(can);
      });
      can.addEventListener('blur', function () {
        wash(null);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var phone = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('[data-collection-posts-carousel]').forEach(function (root) {
      var $track = jQuery(root).find('[data-collection-posts-track]');
      if ($track.children().length < 1) return;

      var options = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: parseInt(root.dataset.speed, 10) || 4000,
        pauseOnHover: root.dataset.pauseOnHover === 'true',
        responsive: [
          {
            breakpoint: 749,
            settings: { slidesToShow: 1 }
          }
        ]
      };

      // The mobile shop all layout is a native scroll-snap row on phones,
      // so slick only runs there from 750px up.
      var nativeOnPhone = root.classList.contains('collection-posts--mobile-comp');

      function sync() {
        var useSlick = !(nativeOnPhone && phone.matches);
        var running = $track.hasClass('slick-initialized');
        if (useSlick && !running) $track.slick(options);
        if (!useSlick && running) $track.slick('unslick');
      }

      sync();
      if (nativeOnPhone) phone.addEventListener('change', sync);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-section]').forEach(function (root) {
      var sectionId = root.dataset.sectionId;

      // Re-bound after every swap, since the fetched HTML replaces these
      // pill elements outright — listeners on the old ones would just be
      // discarded along with them.
      function bindFilterPills() {
        root.querySelectorAll('.collection-filters__pill').forEach(function (pill) {
          pill.addEventListener('click', function (event) {
            event.preventDefault();
            var url = pill.getAttribute('href');
            history.pushState({}, '', url);
            loadFilteredResults(url);
          });
        });
      }

      function loadFilteredResults(url) {
        root.classList.add('is-loading');

        var separator = url.indexOf('?') === -1 ? '?' : '&';
        fetch(url + separator + 'section_id=' + sectionId)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshRoot = doc.querySelector('[data-collection-section]');
            if (!freshRoot) throw new Error('section markup not found in response');

            root.innerHTML = freshRoot.innerHTML;
            root.classList.remove('is-loading');
            bindFilterPills();

            // innerHTML never executes the <script> tags it inserts, so the
            // swapped-in cards need re-binding by hand. The swap destroys
            // the old [data-groovy-cards] grid outright, so this both
            // disposes the WebGL context that belonged to it and builds one
            // for the grid that replaced it — see assets/groovy-cards.js.
            if (window.groovyCardsRefresh) window.groovyCardsRefresh();
          })
          .catch(function () {
            // Falls back to a normal full-page navigation rather than
            // leaving the click looking like it did nothing.
            window.location.href = url;
          });
      }

      bindFilterPills();

      // Back/forward browser navigation between filter states — pushState
      // above only updates the URL bar, it doesn't reload content on its
      // own.
      window.addEventListener('popstate', function () {
        loadFilteredResults(window.location.href);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Reports this bar's real rendered height as a CSS custom property so
    // other components (see .header__mega-panel's top in
    // blocks/mega-menu.liquid) can position themselves right below it
    // instead of guessing a fixed value — a ResizeObserver (rather than just
    // a load-time measurement) catches height changes from text wrapping,
    // late-loading fonts, or the slick carousel init below.
    var bar = document.querySelector('[data-announcement-bar]');
    if (bar) {
      var setHeight = function () {
        document.documentElement.style.setProperty('--announcement-bar-height', bar.offsetHeight + 'px');
      };
      setHeight();
      new ResizeObserver(setHeight).observe(bar);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    jQuery('[data-announcement-bar]').each(function () {
      var $bar = jQuery(this);
      var $track = $bar.find('.announcement-bar__track');
      var $group = $track.find('.announcement-bar__group').first();

      if ($group.children().length < 1 || reduceMotion) return;

      // The duplicate .announcement-bar__group slick loops into is already
      // in the markup (see the section's own Liquid) — rendered there
      // instead of cloned here so it exists from first paint rather than
      // only once this script has loaded and run.

      $track.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: parseInt($bar.data('speed'), 10) || 8000,
        cssEase: 'linear',
        pauseOnHover: $bar.data('pause-on-hover') !== false,
        pauseOnFocus: false
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ingredient-slider]').forEach(function (root) {
      var track = root.querySelector('[data-ingredient-track]');
      var btnPrev = root.querySelector('[data-ingredient-nav="prev"]');
      var btnNext = root.querySelector('[data-ingredient-nav="next"]');

      if (!track) return;

      // The scroll container is the track's parent -- the track itself has to
      // stay wider than the screen for the cards to sit in one row.
      var scroller = track.parentElement;

      function step() {
        var firstCard = track.children[0];
        if (!firstCard) return 0;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      // Read from the scroller rather than from a counter of our own: a swipe
      // moves it without going through the buttons, and momentum lands on
      // fractional pixels, hence the 1px slack at both ends.
      function updateNav() {
        var maxOffset = scroller.scrollWidth - scroller.clientWidth;
        if (btnPrev) btnPrev.disabled = scroller.scrollLeft <= 1;
        if (btnNext) btnNext.disabled = scroller.scrollLeft >= maxOffset - 1;
      }

      function scrollByStep(direction) {
        // 'auto' rather than 'smooth' for a visitor who asked for less motion:
        // the CSS rule alone cannot reach a behaviour named in the call.
        scroller.scrollBy({
          left: direction * step(),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      if (btnPrev) {
        btnPrev.addEventListener('click', function () {
          scrollByStep(-1);
        });
      }

      if (btnNext) {
        btnNext.addEventListener('click', function () {
          scrollByStep(1);
        });
      }

      scroller.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);

      updateNav();

      root.querySelectorAll('[data-ingredient-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-ingredient-card]');
          if (!card) return;
          var isExpanded = card.classList.toggle('is-expanded');
          btn.textContent = isExpanded ? btn.dataset.labelLess : btn.dataset.labelMore;
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

          // The panel is slid behind the card rather than removed, so it has to
          // be hidden from assistive tech by hand or its copy is read out while
          // the card still looks closed.
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) {
            if (isExpanded) {
              panel.removeAttribute('aria-hidden');
            } else {
              panel.setAttribute('aria-hidden', 'true');
            }
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logos-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    jQuery('[data-brand-logos-carousel]').each(function () {
      var $carousel = jQuery(this);
      var $track = $carousel.find('.brand-logos__track');
      var $group = $track.find('.brand-logos__group').first();

      if ($group.children().length < 1 || reduceMotion) return;

      // The duplicate .brand-logos__group slick loops into is already in
      // the markup (see the section's own Liquid) — rendered there
      // instead of cloned here so it exists from first paint rather than
      // only once this script has loaded and run. Nothing left to set up
      // before slick() below except slick() itself.

      $track.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: parseInt($carousel.data('speed'), 10) || 6000,
        cssEase: 'linear',
        pauseOnHover: $carousel.data('pause-on-hover') !== false,
        pauseOnFocus: false
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scroll-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-scroll-video]').forEach(function (wrapper) {
      var video = wrapper.querySelector('video');
      if (!video) return;

      var threshold = parseFloat(wrapper.dataset.threshold) || 0.5;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: threshold }
      );

      observer.observe(wrapper);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.testimonials').forEach(function (root) {
      var $root = jQuery(root);
      var $track = $root.find('[data-testimonials-track]');
      /* Captured BEFORE slick runs: it wraps these in its own .slick-list /
         .slick-track, so $track.children() afterwards is the list, not the
         slides. The elements themselves are the same ones either way. Note
         slick only clones slides when fade is off, so these indices keep
         matching slick's own throughout. */
      var slides = $track.children();
      if (slides.length < 1) return;

      /** The .testimonial-slide inside slick's per-block wrapper. */
      function slideAt(index) {
        var wrapper = slides.eq(index);
        return wrapper.find('.testimonial-slide').get(0) || wrapper.get(0);
      }

      function applyAccent(index) {
        var slide = slideAt(index);
        if (!slide) return;
        var color = slide.style.getPropertyValue('--card-color');
        if (color) root.style.setProperty('--accent', color);
      }

      applyAccent(0);
      if (slides.length < 2) return;

      /* Movement nobody asked for is exactly what this setting is about, so
         autoplay is skipped outright — the dots still work, and the deal
         below is silenced in CSS for the same reason. */
      var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      var delay = parseInt(root.dataset.autoplaySpeed, 10) || 4000;

      $track.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        /* adaptiveHeight OFF deliberately. Every slide is the same height now
           (see .testimonial-slide's min-height in blocks/testimonial.liquid),
           so it has nothing to adapt to — and it was animating .slick-list to
           a rounded-down height, which shaved the bottom edge of the panel and
           flattened the photo's two bottom corners. */
        arrows: false,
        dots: true,
        fade: true,
        speed: 500,
        autoplay: autoplay,
        autoplaySpeed: delay,
        /* Hover, keyboard focus and a hovered dot all pause: each of them is
           the visitor saying they are reading this one. */
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: true
      });

      /* And off screen, so a carousel three sections down isn't burning
         through its slides before anyone has scrolled to it — the visitor
         would arrive mid-deck with no idea they had missed anything. */
      if (autoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              $track.slick(entry.isIntersecting ? 'slickPlay' : 'slickPause');
            });
          },
          { threshold: 0.2 }
        ).observe(root);
      }

      /* The deal. The classes are what the keyframes in
         blocks/testimonial.liquid hang off; everything about the movement
         itself lives there. */
      function deal(index, className) {
        var slide = slideAt(index);
        if (!slide) return;
        slide.classList.remove('is-dealing-out', 'is-dealing-in');
        /* Forces a reflow between the removal and the add. Without it, a
           click landing mid-deal on a slide that already carries the class
           replays nothing at all — the browser never sees it leave. */
        void slide.offsetWidth;
        slide.classList.add(className);
      }

      function clearDeal() {
        slides.each(function (_, wrapper) {
          var slide = jQuery(wrapper).find('.testimonial-slide').get(0) || wrapper;
          slide.classList.remove('is-dealing-out', 'is-dealing-in');
        });
      }

      $track.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        applyAccent(nextSlide);
        if (currentSlide === nextSlide) return;
        deal(currentSlide, 'is-dealing-out');
        deal(nextSlide, 'is-dealing-in');
      });

      $track.on('afterChange', clearDeal);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Shared by every mega menu and plain submenu below, so opening one
    // closes all the others — clicking a second trigger directly (rather
    // than clicking blank space) doesn't reach the "close on outside click"
    // listeners below, since the trigger's own click handler stops the
    // event from ever bubbling that far. Without this, two dropdowns could
    // end up open at once.
    var closers = [];

    function closeOthers(except) {
      closers.forEach(function (close) {
        if (close.owner !== except) close();
      });
    }

    // Independent of the overlay-scroll logic below (which only runs on the
    // homepage's transparent header) — mega menus need to open on every page.
    document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
      var trigger = menu.querySelector('[data-mega-menu-trigger]');
      if (!trigger) return;

      var close = function () {
        menu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };
      close.owner = menu;
      closers.push(close);

      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = !menu.classList.contains('is-open');
        closeOthers(menu);
        if (willOpen) {
          menu.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          close();
        }
      });

      document.addEventListener('click', function (event) {
        if (!menu.contains(event.target)) close();
      });

      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });

    // Click/tap toggle for each plain submenu — :hover doesn't work on
    // touch, the same reasoning the mega-menu trigger above already
    // accounts for. Joins the same closers registry as the mega menus
    // above, so opening a submenu closes an open mega menu and vice versa.
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (submenuToggle) {
      var item = submenuToggle.closest('.header__menu-item');
      if (!item) return;

      var close = function () {
        item.classList.remove('is-open');
        submenuToggle.setAttribute('aria-expanded', 'false');
      };
      close.owner = item;
      closers.push(close);

      submenuToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closeOthers(item);
        if (willOpen) {
          item.classList.add('is-open');
          submenuToggle.setAttribute('aria-expanded', 'true');
        } else {
          close();
        }
      });

      document.addEventListener('click', function (event) {
        if (!item.contains(event.target)) close();
      });
    });

    /* The magnifier's dropdown. Joins the same closers registry as the menus
       above, so it and an open mega menu can never be on screen together —
       they occupy the same strip of the page.

       The suggestions inside it are not this script's business: they come
       from assets/predictive-search.js, which finds the field by its own
       data attribute wherever it happens to be. */
    var searchWrap = document.querySelector('[data-header-search]');
    var searchToggle = searchWrap && searchWrap.querySelector('[data-header-search-toggle]');

    if (searchWrap && searchToggle) {
      var searchInput = searchWrap.querySelector('[data-predictive-input]');
      var predictPanel = searchWrap.querySelector('[data-predictive-panel]');

      var closeSearch = function () {
        searchWrap.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      };
      closeSearch.owner = searchWrap;
      closers.push(closeSearch);

      var openSearch = function () {
        closeOthers(searchWrap);
        searchWrap.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        // The point of the dropdown is to type in it. The panel fades in over
        // 200ms but is already visible and hittable from frame one (see
        // .header__search-panel's staggered visibility), so focus can land
        // straight away.
        if (searchInput) searchInput.focus();

        // On a phone the drawer covers the whole header, so the two cannot
        // share the screen. Announced rather than called directly: the
        // drawer's own close function is defined further down, and this is
        // the same event convention assets/cart-ajax.js already uses to get
        // the drawer out of its way.
        document.dispatchEvent(new CustomEvent('header-search:open'));
      };

      /* Hover opens it on a mouse, exactly like the mega menus next to it —
         reaching the field should not cost a click. Gated on a real hovering
         pointer: on a touch screen `mouseenter` fires from the tap itself,
         which would open on the same gesture the click handler below is
         already handling, and the two would fight over one tap.

         There is no matching mouseleave. Opening moves focus into the field,
         so a dropdown that closed on mouse-out would yank the caret out from
         under someone who had started typing and moved the pointer away. It
         closes the ways a focused field should: Escape, a click outside, the
         icon again, or opening one of the menus beside it. */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        searchWrap.addEventListener('mouseenter', function () {
          if (searchWrap.classList.contains('is-open')) return;
          openSearch();
        });

        // And closes when the pointer leaves it, exactly like the mega menus.
        // The blur goes with it: the field keeps focus while open (that is the
        // point of opening it), and a focused caret sitting in a panel that is
        // no longer on screen would keep swallowing what gets typed next.
        searchWrap.addEventListener('mouseleave', function () {
          if (!searchWrap.classList.contains('is-open')) return;
          if (searchInput) searchInput.blur();
          closeSearch();
        });
      }

      searchToggle.addEventListener('click', function (event) {
        // A modified click is "open the results page in a tab", which is what
        // the href is still there for — leave it alone.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        /* Deliberately NOT stopPropagation, unlike the menu triggers above:
           the click has to reach document level so the OTHER search field's
           suggestion panel closes itself (each one closes on a click outside
           its own root — see assets/predictive-search.js). On the search page
           there are two fields, and without this the page's panel stayed open
           underneath the dropdown. Nothing here depends on the event being
           stopped: closeOthers below already closes the menus that the
           outside-click listeners would have. */

        if (searchWrap.classList.contains('is-open')) {
          closeSearch();
          return;
        }

        openSearch();
      });

      document.addEventListener('click', function (event) {
        if (!searchWrap.contains(event.target)) closeSearch();
      });

      /* Escape closes one layer at a time: the suggestions if they are up,
         the dropdown itself if they are not. Bound on the CAPTURE phase
         because the field's own Escape handler (assets/predictive-search.js)
         would otherwise have already hidden the panel by the time this ran,
         and both layers would collapse on one press. */
      searchWrap.addEventListener(
        'keydown',
        function (event) {
          if (event.key !== 'Escape') return;
          if (predictPanel && !predictPanel.hidden) return;
          closeSearch();
          searchToggle.focus();
        },
        true
      );
    }

    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-header-menu]');
    var backdrop = document.querySelector('[data-menu-backdrop]');
    if (!toggle || !drawer) return;

    function closeDrawer() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('menu-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('menu-open');
      if (backdrop) backdrop.classList.add('is-open');
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    // The drawer is mobile-only CSS (see the @media block above) — if the
    // viewport grows past that breakpoint while it's open (e.g. rotating a
    // tablet, or resizing a browser window), close it so its state doesn't
    // stay stuck open once the drawer styling itself stops applying.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) closeDrawer();
    });

    // The side cart (sections/cart-drawer.liquid) opens on top of this one
    // and takes over the scroll lock on <html>, which this drawer also holds
    // through .menu-open. Both writing it means whichever closes FIRST
    // unlocks the page under the other — so this one gets out of the way
    // instead. assets/cart-ajax.js fires the event as it opens.
    document.addEventListener('cart-drawer:open', closeDrawer);
    document.addEventListener('header-search:open', closeDrawer);
  });

  document.addEventListener('DOMContentLoaded', function () {
    /* Every page, not just the overlay ones: --header-top-progress drives
       the snap from the announcement bar's height to 0, which is what
       makes the header stick on interior pages too. The transparency
       phases below are read only by header--overlay's CSS, so they cost
       nothing where they don't apply. */
    var header = document.querySelector('[data-header-scroll]');
    if (!header) return;

    var root = document.documentElement;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.style.setProperty('--hero-logo-progress', 1);
      root.style.setProperty('--header-top-progress', 1);
      root.style.setProperty('--header-logo-progress', 1);
      root.style.setProperty('--header-background-progress', 1);
      return;
    }

    /* The flight (see .hero__logo.is-flying in sections/hero.liquid). Where
       there's a hero logo AND a header logo for it to land in, the hero's
       own logo is not faded out and replaced by the header's — it is moved
       and scaled into the header's logo slot, and only hands over to the
       real one once it is already sitting exactly on top of it.

       FLIP-style: both ends are MEASURED rather than hard-coded, because
       both of them move with the viewport width, the page margin and
       whatever logo assets the merchant set. Nothing about the trajectory
       is written down here — only how long the scroll takes. */
    var heroLogo = document.querySelector('[data-hero-logo]');
    var headerLogoBox = header.querySelector('.header__logo');
    var headerLogoImage = headerLogoBox
      ? headerLogoBox.querySelector('.header__logo-image--light') || headerLogoBox.querySelector('img')
      : null;
    // header--overlay is the one place the two logos are ever both on
    // screen: elsewhere the header's logo is visible from the start, so
    // there is nothing to fly into. A collection hero has no logo of its
    // own either (see sections/collection-hero.liquid).
    var flying = !!(heroLogo && headerLogoImage && header.classList.contains('header--overlay'));

    // Phase 1: the flight itself — how far the user scrolls between the
    // logo sitting in the hero and it having landed in the bar. Everything
    // below is sequenced off it, so the bar only starts becoming a bar once
    // the logo has arrived. Without a flight this is the old plain
    // fade-out distance: short, since the logo lives in the top slice of
    // the hero and there's no reason to tie it to the hero's full height.
    var heroLogoFadeDistance = flying ? 220 : 180;

    // Phase 2: the header snaps up to top: 0 almost immediately — a much
    // shorter, independent distance from everything else below. It matters
    // to the flight too: the landing spot is measured relative to the
    // header, which by then has long finished this snap.
    var headerTopSnapDistance = 20;

    // Phase 3: the handover. The header's real logo fades in over the last
    // stretch of the flight, while the flying one fades out across exactly
    // the same stretch (see handoverStart below) — by then the two are
    // sitting in the same place at the same size, so the crossfade is there
    // to cover subpixel differences, not to move anything. Without a
    // flight, the header's logo just fades in on its own fixed distance.
    var handoverStart = 0.88;
    var headerLogoStart = flying ? heroLogoFadeDistance * handoverStart : 120;
    var headerLogoFadeDistance = flying ? heroLogoFadeDistance * (1 - handoverStart) : 100;

    // Phase 4: the header's background/text color come last. With a flight
    // they wait for it to land: the logo is a white image travelling over
    // the hero photo, so the bar has to stay fully transparent underneath it
    // the whole way, and only then thicken into a bar (which is also what
    // crossfades the white logo to the dark one — see --header-solidity).
    // Without a flight they start alongside the logo but run slightly
    // longer, so they finish just after it rather than landing together.
    // Deliberately fixed distances like the phases above, not tied to the
    // hero's height — the header should react to the user's scroll
    // position, not to how tall a particular hero image happens to be.
    var headerBackgroundStart = flying ? heroLogoFadeDistance : 120;
    var headerBackgroundFadeDistance = 150;

    var flight = null;

    /* Resting geometry of both ends, in the one shape the frame loop needs.
       Both are measured with their scroll-driven transforms taken out of the
       way, so what comes back is where each END is, not wherever the last
       frame happened to leave them.

       The hero logo is measured in DOCUMENT coordinates: it scrolls with the
       page, so its viewport position has to be recomputed every frame. The
       header's is measured relative to the header itself, which is fixed —
       once the top snap above is done, header top is 0, so the offset
       within it IS the viewport position it lands at. */
    var measureFlight = function () {
      var heroInline = heroLogo.style.transform;
      var headerInline = headerLogoBox.style.transform;
      heroLogo.style.transform = 'none';
      headerLogoBox.style.transform = 'none';

      var headerBox = header.getBoundingClientRect();
      var from = heroLogo.getBoundingClientRect();
      var to = headerLogoImage.getBoundingClientRect();

      heroLogo.style.transform = heroInline;
      headerLogoBox.style.transform = headerInline;

      // Images that haven't loaded yet measure as zero-width, which would
      // bake a scale of 0 (or Infinity) into the whole flight. Returning
      // null just means "try again next frame" — see updateProgress.
      if (!from.width || !to.width) return null;

      return {
        fromLeft: from.left,
        fromDocTop: from.top + window.scrollY,
        toLeft: to.left,
        toTop: to.top - headerBox.top,
        scale: to.width / from.width
      };
    };

    var ticking = false;

    var updateProgress = function () {
      var scrollY = window.scrollY;
      var heroLogoProgress = Math.min(Math.max(scrollY / heroLogoFadeDistance, 0), 1);
      var headerTopProgress = Math.min(Math.max(scrollY / headerTopSnapDistance, 0), 1);
      var headerLogoProgress = Math.min(Math.max((scrollY - headerLogoStart) / headerLogoFadeDistance, 0), 1);
      var headerBackgroundProgress = Math.min(
        Math.max((scrollY - headerBackgroundStart) / headerBackgroundFadeDistance, 0),
        1
      );

      root.style.setProperty('--hero-logo-progress', heroLogoProgress);
      root.style.setProperty('--header-top-progress', headerTopProgress);
      root.style.setProperty('--header-logo-progress', headerLogoProgress);
      root.style.setProperty('--header-background-progress', headerBackgroundProgress);

      if (flying) {
        if (!flight) {
          flight = measureFlight();
          // Held back until here so that a measurement that couldn't be
          // taken yet leaves the fallback rule in sections/hero.liquid
          // running as-is, rather than a top-left-origin version of it.
          if (flight) heroLogo.classList.add('is-flying');
        }

        if (flight) {
          /* Smoothstep rather than the raw progress: the logo eases out of
             the hero and settles into the bar instead of starting and
             stopping at full speed, which is most of what makes the travel
             read as one movement rather than a value being dragged. Position
             and scale share it, so the logo stays a rigid object — it
             shrinks BECAUSE it's moving away, not on its own schedule. */
          var eased = heroLogoProgress * heroLogoProgress * (3 - 2 * heroLogoProgress);
          var scale = 1 + (flight.scale - 1) * eased;
          var fromTop = flight.fromDocTop - scrollY;

          heroLogo.style.transform =
            'translate3d(' +
            (flight.toLeft - flight.fromLeft) * eased +
            'px, ' +
            (flight.toTop - fromTop) * eased +
            'px, 0) scale(' +
            scale +
            ')';
          // The mirror image of the header logo's own fade-in above, so the
          // pair is never brighter or dimmer than one logo mid-handover.
          heroLogo.style.opacity = 1 - headerLogoProgress;
        }
      }

      ticking = false;
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    };

    /* Anything that can move either end invalidates the measurement: a
       resize (both ends follow the viewport width), and the load event —
       at DOMContentLoaded the logo images may still be measuring as zero,
       and a font swap or a late image can reflow the hero under them. */
    var remeasure = function () {
      flight = null;
      onScroll();
    };

    updateProgress();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-index"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ingredients-index]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-letter-filter]');
      var items = root.querySelectorAll('[data-ingredient-letter]');
      var emptyMessage = root.querySelector('[data-ingredients-empty]');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var letter = button.dataset.letterFilter;

          buttons.forEach(function (b) {
            b.classList.remove('is-active');
          });
          button.classList.add('is-active');

          var visibleCount = 0;
          items.forEach(function (item) {
            var matches = letter === 'all' || item.dataset.ingredientLetter === letter;
            item.hidden = !matches;
            if (matches) visibleCount += 1;
          });

          if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  /* The cans lean toward the cursor. All this does is write the pointer's
     position on the section as two -1..1 numbers; the CSS above decides how
     far each can travels and eases it there (see .newsletter-signup__can-depth).
     Nothing here reads layout except one getBoundingClientRect per move, and
     nothing here animates — so there is no frame loop and no jank to tune.
     What the cans actually do with these two numbers is roll and pitch, the
     home's two rotations rather than a slide.

     The normalisation is the one assets/groovy-cards-markup.js uses for the
     product cards, y inverted the same way, so a cursor crossing this page
     and a cursor crossing the home behave alike. */
  (function () {
    var wired = new WeakSet();

    function wire(section) {
      if (wired.has(section)) return;
      wired.add(section);

      var move = function (event) {
        var rect = section.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        section.style.setProperty('--ns-px', ((event.clientX - rect.left) / rect.width - 0.5) * 2);
        section.style.setProperty('--ns-py', ((event.clientY - rect.top) / rect.height - 0.5) * -2);
      };

      /* Back to rest on the way out, and on pointercancel too: a drag that
         leaves the section never fires pointerleave in some browsers, which
         would strand the cans off-centre. */
      var rest = function () {
        section.style.setProperty('--ns-px', 0);
        section.style.setProperty('--ns-py', 0);
      };

      section.addEventListener('pointermove', move, { passive: true });
      section.addEventListener('pointerleave', rest);
      section.addEventListener('pointercancel', rest);
    }

    function init() {
      /* Touch and pen have no cursor to follow, and someone who asked for
         reduced motion did not ask for this. Both are checked at wiring time
         rather than per event, so those visitors never pay for the listener. */
      if (!window.matchMedia('(hover: hover)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      document.querySelectorAll('.newsletter-signup').forEach(wire);
    }

    document.addEventListener('DOMContentLoaded', init);
    /* The theme editor replaces the section's markup on every settings
       change, so the new element needs wiring; the WeakSet keeps the ones
       already done from being wired twice. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    jQuery('[data-text-slider]').each(function () {
      var $slider = jQuery(this);
      var $track = $slider.find('.text-slider__track');
      var $slides = $track.find('.text-slider__slide');

      if ($slides.length < 1) return;

      var setActiveSlideVars = function (index) {
        var $slide = $slides.eq(index);
        var color = $slide.data('color');
        var background = $slide.data('background');
        if (color) $slider[0].style.setProperty('--active-slide-color', color);
        if (background) $slider[0].style.setProperty('--active-slide-background', background);
      };

      setActiveSlideVars(0);

      $track.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        setActiveSlideVars(nextSlide);
      });

      if ($slides.length < 2) return;

      $track.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        // Off: resizing to each message made the card grow and shrink on
        // every change, shifting the page below it on phones. The track is
        // flex instead (see the stylesheet), so the card holds the tallest.
        adaptiveHeight: false,
        infinite: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: parseInt($slider.data('speed'), 10) || 5000,
        pauseOnHover: true,
        pauseOnFocus: false
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
